import { AsyncPipe, NgIf } from '@angular/common';
import { AfterViewInit, Component, Input, Output, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Countertop, Cutout, CutoutPoint, CuttingStandardCutout } from 'cloud-shared-lib';
import * as _ from 'lodash';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

import { CutoutsCreatorComponent } from '../../../../components/cutouts-creator/cutouts-creator.component';
import { CountertopSchemaComponent } from '../../../countertop-schema/countertop-schema.component';

@Component({
  selector: 'csl-cutout-adder',
  templateUrl: './cutout-adder.component.html',
  styleUrls: ['./cutout-adder.component.scss'],
  standalone: true,
  imports: [CutoutsCreatorComponent, NgIf, AsyncPipe, ReactiveFormsModule, CountertopSchemaComponent],
})
export class CutoutAdderComponent implements AfterViewInit {
  thisCutoutBasePoint = CutoutPoint;
  unsubscribe$: Subject<void> = new Subject();
  redrawing$: Subject<void> = new Subject();

  tempCountertop: Countertop;
  countertopOrigin: Countertop;
  cutout: Cutout;

  @Input() set countertop(val: Countertop) {
    this.countertopOrigin = val;
    this.tempCountertop = _.cloneDeep(val);
  }

  @Input() schema: CuttingStandardCutout;

  @Output() stateChanged$ = new BehaviorSubject(false);

  @ViewChild(CountertopSchemaComponent, { static: true }) countertopSchema: CountertopSchemaComponent;

  constructor() {
    this.redrawing$.pipe(takeUntil(this.unsubscribe$), debounceTime(500)).subscribe(() => {
      this.redraw();
    });
  }

  ngAfterViewInit(): void {
    this.redraw();
  }

  formChangeHandler(cutout: Cutout): void {
    this.cutout = cutout;
    this.fillTempCountertop(cutout);
    this.redrawing$.next();
  }

  redraw(): void {
    this.countertopSchema.render(this.tempCountertop);
  }

  fillTempCountertop(item: Cutout): void {
    const outline = this.tempCountertop.outline;
    const outlineOrigin = this.countertopOrigin.outline;

    outline.cutouts = [..._.cloneDeep(outlineOrigin.cutouts), item];
  }
}
